import { http } from './http';

export interface ReferralCryptKeys {
  hash: string;
  iv: string;
}

export function getDat(filename: string): Promise<any> {
  return http
    .get(http.url.file(`/referral/${filename}.dat`))
    .then(response => http.handleResponse(response));
}

export async function getDeryptKeys(
  svid: string,
  token: string
): Promise<ReferralCryptKeys> {
  try {
    const url = http.url.api(
      `/s/referral/encrypt-keys?${http.query({ svid, token })}`,
      1
    );
    const res = await http.get(url);
    const { status, data, errmsg = '' } = await http.handleResponse(res);

    if (!status) {
      throw new Error(errmsg);
    }

    return data;
  } catch (error) {
    throw error;
  }
}

export function getShortenData(token: string): Promise<any> {
  return http
    .get(http.url.shorten(`/${token}`))
    .then(response => http.handleResponse(response));
}

export function checkShortenData(token: string) {
  return http.head(http.url.shorten(`/${token}`));
}

export async function encrypt(
  svid: string,
  token: string
): Promise<{ enc: string }> {
  try {
    const url = http.url.api(`/s/referral/encrypt`, 1);
    const body = new FormData();
    body.append('svid', svid);
    body.append('token', token);
    const res = await http.post(url, { body });
    const { status, data, errmsg = '' } = await http.handleResponse(res);

    if (!status) {
      throw new Error(errmsg);
    }

    return data;
  } catch (error) {
    throw error;
  }
}

export function saveLog(svid: string, token: string) {
  const url = http.url.api(`/s/referral/logger`, 1);
  const body = new FormData();
  body.append('svid', svid);
  body.append('filename', token);
  http.post(url, { body });
}
